import React, { useState, useEffect } from 'react';
import StarRating from '../Rating/StarRating'
import ReviewServices from '../../services/ReviewServices';

function ViewReview({ review, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        reply: '',
    });
    useEffect(() => {
        if (review) {
            setFormValues({
                reply: review?.reply || '',
            });
        }
    }, [review]);
    if (!review) return null;
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const formData = new FormData();
            for (const key in formValues) {
                if (key !== 'image' || formValues[key] instanceof File) {
                    formData.append(key, formValues[key]);
                }
            }

            await ReviewServices.updateReview(review.id, formValues);
            alert('Review updated successfully');
            onSuccess();
            closeModal();
        } catch (error) {
            alert('Failed to update Review');
        }
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return 'Invalid Date';
        }

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${day}-${month}-${year}`;
    };
    const url = 'uploads/';


    return (
        <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="manufacturerModal">Review Details</h5>
                        <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="container">

                                {/* User Info Section */}
                                <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                                    <ul className='user-details list-unstyled d-flex justify-content-between'>
                                        <li>
                                            <span>User Name</span>
                                            <p>{review?.user?.name || review?.investor?.name}</p>
                                        </li>
                                        <li>
                                            <span>Rating</span>
                                            <p><StarRating rating={review?.rating} /></p>
                                        </li>
                                        <li>
                                            <span>Date Submitted</span>
                                            <p>{formatDate(review?.createdAt) || 'N/A'}</p>
                                        </li>
                                    </ul>
                                    <ul className='user-details list-unstyled d-flex'>
                                        <li>
                                            <span>Cottage Name</span>
                                            <p>{review?.cottage?.name || 'N/A'}</p>
                                        </li>
                                        <li>
                                            <span>Status</span>
                                            <p style={{color:'#699836'}}>{review?.status || 'N/A'}</p>
                                        </li>
                                        <li>
                                            
                                        </li>
                                    </ul>
                                    <ul className='user-details list-unstyled'>
                                        <li className='text-start'>
                                            <span>Review Text</span>
                                            <p>{review?.comment || 'N/A'}</p>
                                        </li>
                                    </ul>
                                </div>
                                <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                                    <h4>Admin Reply (if any)</h4>
                                    <textarea className='form-control' type = 'text' name='reply' value={formValues.reply} onChange={handleInputChange} minLength={10} ></textarea>
                                <div className="modal-footer d-flex justify-content-start">
                                    <button type="submit" className="site-btn-green" style={{ marginBlock: '15px', backgroundColor:'#699836', textAlign:'right' }}>
                                        Submit
                                    </button>
                                </div>
                                </div>

                            </div>
                        </form>

                    </div>
                </div>

            </div>
        </div>
    );
}

export default ViewReview;
